<template>
  <div class="modal-backdrop">
    <div class="modal-content">
      <div class="modal-content-header">
        <button @click="$emit('close')">&times;</button>
        <div>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.modal-backdrop {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1000;

  .modal-content {
    display: flex;
    flex-direction: column;
    max-height: 100vh;
    overflow: auto;

    .modal-content-header {
      text-align: right;

      button {
        background: none;
        border: none;
        color: white;
        cursor: pointer;
        font-size: 40px;
        line-height: 1;
      }
    }
  }
}
</style>
